import React from "react";

export const CheckEmoji = <span css={{ marginRight: 2 }}>✅</span>;
export const StarEmoji = <span css={{ marginRight: 2 }}>⭐️</span>;
